(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["namture-board-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namture-board-guide')) {
  customElements.define('namture-board-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.step = 0;
      this.questions = Array.from(this.querySelectorAll('[data-question]'));
      this.querySelector('.nbg-interactive').hidden = false;
      this.addEventListener('change', () => { this.querySelector('[data-error]').hidden = true; });
      this.handleClick = event => {
        if (!this.contains(event.target)) return;
        const option = event.target.closest('.nbg-option');
        const button = event.target.closest('button');
        if (!option && !button) return;
        event.stopImmediatePropagation();
        if (option) {
          this.querySelector('[data-error]').hidden = true;
          return;
        }
        event.preventDefault();
        if (button.hasAttribute('data-next')) {
          if (!this.questions[this.step].querySelector('input:checked')) {
            this.querySelector('[data-error]').hidden = false;
            this.questions[this.step].querySelector('input').focus();
            return;
          }
          if (this.step < 2) this.showStep(this.step + 1);
          else this.showResult();
        } else if (button.hasAttribute('data-back')) {
          this.showStep(this.step - 1);
        } else if (button.hasAttribute('data-edit')) {
          this.showStep(0);
        } else if (button.hasAttribute('data-restart')) {
          this.querySelectorAll('input').forEach(input => { input.checked = false; });
          this.showStep(0);
        }
      };

    }
    disconnectedCallback() {

      this.ready = false;
    }
    showStep(step) {
      this.step = Math.max(0, Math.min(2, step));
      this.querySelector('[data-result]').hidden = true;
      this.querySelector('[data-questions]').hidden = false;
      this.questions.forEach((question,index) => { question.hidden = index !== this.step; });
      this.querySelector('[data-step]').textContent = String(this.step + 1);
      this.querySelector('[data-bar]').style.width = ((this.step + 1) / 3 * 100) + '%';
      this.querySelector('[data-back]').hidden = this.step === 0;
      this.querySelector('[data-next]').textContent = (this.step === 2 ? this.dataset.show : this.dataset.next) + ' →';
      this.querySelector('[data-error]').hidden = true;
      this.questions[this.step].querySelector('legend').focus();
    }
    message(key) { return this.querySelector('[data-message="' + key + '"]').textContent; }
    showResult() {
      const selected = this.questions.map(question => question.querySelector('input:checked'));
      if (selected.some(input => !input)) { this.showStep(selected.findIndex(input => !input)); return; }
      const [use,space,format] = selected.map(input => input.value);
      let result = space === 'compact' ? 'm' : space === 'medium' ? 'l' : format === 'set' ? 'set' : format === 'block' ? 'block' : 'xl';
      this.querySelector('[data-summary]').textContent = selected.map(input => input.closest('label').querySelector('strong').textContent).join(' · ');
      const conflict = this.querySelector('[data-conflict]');
      conflict.hidden = space === 'large' || format === 'single';
      conflict.textContent = conflict.hidden ? '' : this.message('conflict_' + format);
      let useKey = use === 'daily' ? 'use_daily' : use === 'cook' ? (space === 'compact' ? 'small_cook' : 'use_cook') : result === 'set' ? 'use_serve_set' : result === 'block' ? 'use_serve_block' : 'use_serve';
      this.querySelector('[data-use-reason]').textContent = this.message(useKey);
      this.querySelectorAll('[data-card]').forEach(card => { card.hidden = card.dataset.card !== result; });
      this.querySelector('[data-questions]').hidden = true;
      this.querySelector('[data-result]').hidden = false;
      this.querySelector('[data-result-heading]').focus();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namture-desktop-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){document.querySelectorAll('.nm-shop-menu[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.nm-shop-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}});
document.addEventListener('focusin',function(event){document.querySelectorAll('.nm-shop-menu[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false;});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namture-header-language"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  document.querySelectorAll('.namture-language[open]').forEach(function(menu){
    if(!menu.contains(event.target)) menu.open=false;
  });
});
document.addEventListener('keydown',function(event){
  if(event.key==='Escape'){
    document.querySelectorAll('.namture-language[open]').forEach(function(menu){
      menu.open=false;
      menu.querySelector('summary').focus();
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namture-product-care"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var target = event.target;
  if (!(target instanceof Element)) return;
  var opener = target.closest('[data-care-info]');
  if (opener) {
    event.preventDefault();
    var picker = opener.closest('[data-care-picker]');
    var dialog = picker && picker.querySelector('.nt-care-dialog');
    if (dialog && !dialog.open) {
      dialog.showModal();
      dialog.scrollTop = 0;
    }
    return;
  }
  var close = target.closest('[data-care-close]');
  var select = target.closest('[data-care-select]');
  if (close || select) {
    var activeDialog = target.closest('.nt-care-dialog');
    if (!activeDialog) return;
    event.preventDefault();
    if (select) {
      var input = activeDialog.closest('[data-care-picker]').querySelector('[data-product-care]');
      if (input && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    activeDialog.close();
    return;
  }
  if (target.matches('.nt-care-dialog')) {
    var bounds = target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) target.close();
  }
});
  } catch(e) { console.error(e); }
})();

})();
